import { useApiClient } from '@/composables/api-client'
import type { ApiClientCallConfig } from '@/composables/api-client/types'
import dashboardAxiosInstance from '@/store/axios'

export function useDashboardApiClient<T>(config: ApiClientCallConfig) {
    return useApiClient<T>(config, dashboardAxiosInstance)
}
